import { Outlet } from 'react-router-dom';

/**
 * Layout for authentication pages (Login, Register, etc.)
 * This layout does not have any theming applied.
 */
export const AuthLayout = () => {
  return (
    <main>
      <Outlet />
    </main>
  );
};
